(() => {
  // Loaded app pixels can retain automatic click listeners after consent changes.
  // Only after Shopify confirms a restriction, replace the document so its pixel
  // manager initializes with the saved permissions. Never change consent here.
  if (!window.sosConsentReloadBound) {
    window.sosConsentReloadBound = true;
    const purposes = {
      marketingAllowed: 'marketingAllowed',
      analyticsAllowed: 'analyticsProcessingAllowed',
      preferencesAllowed: 'preferencesProcessingAllowed',
      saleOfDataAllowed: 'saleOfDataAllowed'
    };
    let previous = null;
    let reloading = false;
    const readPermissions = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || !Object.values(purposes).every(name => typeof privacy[name] === 'function')) return null;
      return Object.fromEntries(Object.entries(purposes).map(([key, method]) => [key, privacy[method]() === true]));
    };
    const initialize = (attempt = 0) => {
      if (previous !== null) return;
      previous = readPermissions();
      if (previous === null && attempt < 100) setTimeout(() => initialize(attempt + 1), 100);
    };
    document.addEventListener('visitorConsentCollected', event => {
      const current = event.detail;
      if (!current || !Object.keys(purposes).every(key => typeof current[key] === 'boolean')) return;
      const restricted = Object.keys(purposes).some(key => current[key] === false && (!previous || previous[key] === true));
      previous = { ...current };
      if (restricted && !reloading) {
        reloading = true;
        window.location.reload();
      }
    });
    initialize();
    // Also covers very late API initialization before the preferences dialog.
    document.addEventListener('click', event => {
      if (event.target.closest?.('[data-sos-cookie-settings]')) previous = readPermissions() || previous;
    }, true);
  }
  document.querySelectorAll('[data-sos-cookie-settings]').forEach(button => {
    if (button.dataset.sosCookieBound) return;
    button.dataset.sosCookieBound = 'true';
    const status = button.parentElement.querySelector('[data-sos-cookie-status]');
    button.addEventListener('click', async () => {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      if (status) { status.hidden = true; status.textContent = ''; }
      try {
        // Shopify injects the native banner through content_for_header.
        // Wait for a slow connection without loading a second copy or changing consent.
        for (let attempt = 0; attempt < 50 && !window.privacyBanner?.showPreferences; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        if (!window.privacyBanner?.showPreferences) throw new Error('Cookie settings unavailable');
        await window.privacyBanner.showPreferences();
      } catch (error) {
        if (status) {
          status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu und versuche es erneut.';
          status.hidden = false;
        }
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
